
<!-- Header Structure -->
<template>
  <footer class="fotter-custom">
    <div class="container py-3 pl-4 ">
      <div class="row mt-0">
        <div class="col-12 col-md-12 mb-0 text-center">
          <b-navbar-brand class="footer-logo" href="/"><img class="icon footer-logo" alt="Aeru_logo" src="../../assets/top/PC_mobile/images/logo.png"></b-navbar-brand>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>

export default {
    data() {
        return {

        };
    },
    methods: {
    },
    components: {
    },
    async created() {
    },
    watch:{
    }

};
</script>
<style scoped lang="scss"> 
.link{
  color: #FFFFFF
}
.fotter-custom{
    background-color: #000054;
    color: #FFFFFF;
}
.footer-logo {
  width: 28%;
}
.footer-ul {
  list-style: none;
}
@media (max-width: 576px) {
   .footer-ul {
      padding-inline-start: 0px;
    }
}
</style>
